import React from 'react';
import PropTypes from 'prop-types';
import { PieChart, Pie, Cell } from 'recharts';
import map from 'lodash/map';

import { grey500 } from 'material-ui/styles/colors';

import { BRAND } from '../../constants/Constants';

import './StatusChart.css';

const StatusChart = props => {
  const {
    finishedCount,
    totalCount,
    chartSize = 60,
    style
  } = props;
  const data = [
    {
      name: 'Completed',
      value: finishedCount,
      color: BRAND.theme.palette.primary1Color
    },
    {
      name: 'In progress',
      value: totalCount - finishedCount,
      color: BRAND.theme.palette.accent1Color
    }
  ];
  const chartData = totalCount > 0
      ? data
      : [
      {
        name: 'Total',
        value: 1,
        color: grey500
      }
    ];
  const chartFontSize = Math.min(24, Math.max(16, Math.round(chartSize / 100 * 24)));
  return (
    <div className="status-chart" style={style}>
      <div className="status-chart-content" style={{ minHeight: chartSize }}>
        <PieChart width={chartSize} height={chartSize} margin={{ top: 0, left: 0, right: 0, bottom: 0 }}>
          <Pie
            dataKey={'value'}
            data={chartData}
            innerRadius={'75%'}
            outerRadius={'100%'}
            startAngle={90}
            endAngle={-270}
            isAnimationActive={false}
          >
            {map(chartData, e => <Cell key={e.name} fill={e.color} stroke="none" />)}
          </Pie>
        </PieChart>
        <div className="status-chart-text">
          <div
            style={{
              fontSize: chartFontSize,
              lineHeight: '1em'
            }}
          >
            <div
              style={{
                color: chartData[0].color,
                borderBottom: `1px solid ${chartData[0].color}`
              }}
            >
              {finishedCount}
            </div>
            <small>{totalCount}</small>
          </div>
        </div>
      </div>
    </div>
  );
};

StatusChart.propTypes = {
  startedCount: PropTypes.number,
  finishedCount: PropTypes.number,
  totalCount: PropTypes.number,
  chartSize: PropTypes.number,
  style: PropTypes.object
};

export default StatusChart;



// WEBPACK FOOTER //
// ./src/components/chats/StatusChart.js